export default function NotificationInbox({
  notifications,
  unreadCount,
  loading,
  error,
  busyId,
  bulkBusy,
  olderLoading,
  olderError,
  hasMore,
  onMarkAllRead,
  onRetry,
  onOpenNotification,
  onMarkRead,
  onRetryOlder,
  onLoadOlder,
}) {
  return (
    <section
      className="notification-inbox"
      aria-labelledby="notifications-heading"
    >
      <h1 id="notifications-heading">Notifications</h1>
      <p className="notification-summary" role="status">
        {unreadCount} unread notification{unreadCount === 1 ? "" : "s"}
      </p>
      {unreadCount > 0 && (
        <button
          type="button"
          className="notification-mark-all"
          disabled={bulkBusy || loading || busyId !== null}
          onClick={onMarkAllRead}
        >
          {bulkBusy ? "Marking all as read…" : "Mark all as read"}
        </button>
      )}
      {error && (
        <div className="notification-error" role="alert">
          <p>{error}</p>
          <button
            type="button"
            className="notification-retry"
            onClick={onRetry}
          >
            Retry
          </button>
        </div>
      )}
      {loading ? (
        <p className="marketplace-empty" role="status" aria-live="polite">
          Loading notifications…
        </p>
      ) : notifications.length === 0 ? (
        error ? null : (
          <p className="marketplace-empty" role="status">
            You’re all caught up. No notifications yet.
          </p>
        )
      ) : (
        <div className="notification-list">
          {notifications.map((notification) => (
            <article
              className={`notification-card${
                notification.read_at ? "" : " is-unread"
              }`}
              key={notification.id}
            >
              <button
                className="notification-content"
                disabled={busyId === notification.id || bulkBusy}
                onClick={() => onOpenNotification(notification)}
                aria-label={
                  notification.entity_type === "order"
                    ? `Open related order: ${notification.title}`
                    : ["trip", "local_errand"].includes(
                        notification.entity_type
                      )
                    ? `Open related listing: ${notification.title}`
                    : `Read notification: ${notification.title}`
                }
              >
                <span className="notification-heading">
                  <strong>{notification.title}</strong>
                  <time dateTime={notification.created_at}>
                    {new Date(notification.created_at).toLocaleString(
                      "en-PH",
                      { dateStyle: "medium", timeStyle: "short" }
                    )}
                  </time>
                </span>
                <span>{notification.body}</span>
                {notification.entity_type === "order" && (
                  <span className="notification-open-label">
                    Open related order
                  </span>
                )}
                {["trip", "local_errand"].includes(
                  notification.entity_type
                ) && (
                  <span className="notification-open-label">
                    Open related listing
                  </span>
                )}
              </button>
              {!notification.read_at && (
                <button
                  type="button"
                  className="notification-mark-read"
                  disabled={busyId === notification.id || bulkBusy}
                  onClick={() => onMarkRead(notification)}
                >
                  {busyId === notification.id
                    ? "Saving…"
                    : bulkBusy
                    ? "Marking all as read…"
                    : "Mark as read"}
                </button>
              )}
            </article>
          ))}
        </div>
      )}
      {olderError && (
        <div className="notification-error" role="alert">
          <p>{olderError}</p>
          <button
            type="button"
            className="notification-retry"
            disabled={olderLoading}
            onClick={onRetryOlder}
          >
            Retry
          </button>
        </div>
      )}
      {hasMore && (
        <button
          type="button"
          className="notification-load-more"
          disabled={olderLoading || loading}
          onClick={onLoadOlder}
        >
          {olderLoading ? "Loading older notifications…" : "Load older notifications"}
        </button>
      )}
    </section>
  );
}
